<template>
  <div class="pt-5" style="text-align: center;">
    <img src="/static/logo_ciclos_transparente.png" class="ciclos-img-logo" alt="logo">
  </div>
</template>

<script>
  import UserDialog from '@/features/user/UserDialog';


  export default {
    name: 'dashboard',
    data() {
      return {
        userDialogVisible: false,
      };
    },
    components: {
      UserDialog,
    },
    methods: {
      componentInlineClose(data) {
        this.$log.debug(data);
      },
      component() {
        this.$dialog.component(UserDialog, { closeWithEsc: false, widget: false })
          .then((response) => {
            this.$log.debug('Action', response.action);
            this.$log.debug('Data', response.data);
          });
      },
      alert() {
        this.$dialog.alert({ title: 'Titulo do Alert', content: 'Descritivo do alert' })
          .then((response) => {
            this.$log.debug('Action', response.action);
            this.$log.debug('Data', response.data);
          });
      },
      prompt() {
        this.$dialog.prompt({ title: 'Titulo do Prompt ', content: 'Descritivo do prompt' })
          .then((response) => {
            this.$log.debug('Action', response.action);
            this.$log.debug('Data', response.data);
          });
      },
      confirm() {
        this.$dialog.confirm({ title: 'Titulo do Confirm ', content: 'Descritivo do confirm' })
          .then((response) => {
            this.$log.debug('Action', response.action);
            this.$log.debug('Data', response.data);
          });
      },
    },
  };

</script>
<style>
  .ciclos-img-logo {
    width: 60%;
  }
</style>



// WEBPACK FOOTER //
// src/features/dashboard/Dashboard.vue